import { CartCountContext } from "@/lib/main";
import { ReactNode, useState } from "react";

const CartCountProvider = ({ children }: { children: ReactNode }) => {
  const [cartCount, setCartCount] = useState(() => {
    const cart = JSON.parse(localStorage.getItem("cart") || "{}") as {
      [key: string]: number;
    };
    return Object.values(cart).reduce(
      (acc: number, quantity: number) => acc + quantity,
      0,
    );
  });

  return (
    <CartCountContext.Provider value={{ cartCount, setCartCount }}>
      {children}
    </CartCountContext.Provider>
  );
};

export default CartCountProvider;
